export default "__VITE_ASSET__H6Nl7iYV__"